export default __webpack_public_path__ + "static/media/animatecard3.45c9a0b8.jpg";